exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mdl-dialog__content {\n  padding: 0px 24px 24px 24px;\n}\n\n.global-popup__title {\n  padding: 10px;\n}\n\n", ""]);

// exports
